export default __webpack_public_path__ + "static/media/cc_2.4ecbf271.mp3";